module.exports = __webpack_public_path__ + "static/media/Dorehami.28828643.svg";